module.exports = __webpack_public_path__ + "img/Linda Edmonds Turner 1970.2a6ef161.jpg";